import moment from 'moment';
require('daterangepicker');
let dt = null;

export function index(){

    dt = $('#logs_table').DataTable({
        ajax: {
            url: $('#logs_table').attr('url'),
        },
        columns: [
            { width: 120, data: 'created_at', orderable: true, searchable: false, render: datatables.render_datetime_seconds },
            { data: 'user_friendly', orderable: false, searchable: true, render: datatables.render_small_newline },
            { data: 'action', orderable: false, searchable: false },
            { data: 'model', orderable: false, searchable: true, render: datatables.render_small_newline },
            { data: 'model_friendly', orderable: false, searchable: true, render: datatables.render_small_newline },
            { data: 'changes', orderable: false, searchable: true, render: datatables.render_array },
        ],
        order: [[0, 'desc']],
    });

    // dt.on('init', function(e, settings, json){
    // });

    // dt.on('draw', function(e, settings){
    // });

    var start = moment().subtract(29, 'days');
    var end = moment();

    
    function date_export(start, end) {
        $('input[name="export_dates"]').val(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
    }

    function datechange(start, end) {
        $('input[name="daterange"]').val(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
        index_reload();
    }

    let date_range_config = {
        locale: {
            format: 'DD/MM/YYYY',
            separator: ' - ',
            applyLabel: window._('Aplicar'),
            cancelLabel: window._('Cancelar'),
            fromLabel: window._('De'),
            toLabel: window._('A'),
            daysOfWeek: [
                window._('Dom'),
                window._('Lun'),
                window._('Mar'),
                window._('Mie'),
                window._('Jue'),
                window._('Vie'),
                window._('Sab'),
            ],
            monthNames: [
                window._('Enero'),
                window._('Febrero'),
                window._('Marzo'),
                window._('Abril'),
                window._('Mayo'),
                window._('Junio'),
                window._('Julio'),
                window._('Agosto'),
                window._('Septiembre'),
                window._('Octubre'),
                window._('Noviembre'),
                window._('Diciembre'),
            ],
            firstDay: 1
        },
        linkedCalendars: false,
        showCustomRangeLabel: false,
        startDate: start,
        endDate: end,
        ranges: {
        'Hoy': [moment(), moment()],
        'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
        'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
        'Este mes': [moment().startOf('month'), moment().endOf('month')],
        'Último mes': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        },
        alwaysShowCalendars : true,
        opens: 'left',
        autoApply: true,
    };

    $('input[name="daterange"]').daterangepicker(date_range_config, datechange);

    $('#modal_export_logs').on('show.bs.modal', function(event){
        let modal = $(this);
        let daterange = $('input[name="daterange"]').val();
        let array_dates = daterange.split('-');
        let startDate = array_dates[0].trim().replaceAll('/', '-');
        let endDate = array_dates[1].trim().replaceAll('/', '-');


        $('input[name="export_dates"]').daterangepicker({
            locale: {
                format: 'DD/MM/YYYY',
                separator: ' - ',
                applyLabel: window._('Aplicar'),
                cancelLabel: window._('Cancelar'),
                fromLabel: window._('De'),
                toLabel: window._('A'),
                daysOfWeek: [
                    window._('Dom'),
                    window._('Lun'),
                    window._('Mar'),
                    window._('Mie'),
                    window._('Jue'),
                    window._('Vie'),
                    window._('Sab'),
                ],
                monthNames: [
                    window._('Enero'),
                    window._('Febrero'),
                    window._('Marzo'),
                    window._('Abril'),
                    window._('Mayo'),
                    window._('Junio'),
                    window._('Julio'),
                    window._('Agosto'),
                    window._('Septiembre'),
                    window._('Octubre'),
                    window._('Noviembre'),
                    window._('Diciembre'),
                ],
                firstDay: 1
            },
            linkedCalendars: false,
            showCustomRangeLabel: false,
            startDate: moment(startDate, 'DD/MM/YYYY'),
            endDate: moment(endDate, 'DD/MM/YYYY'),
            ranges: {
            'Hoy': [moment(), moment()],
            'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
            'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
            'Este mes': [moment().startOf('month'), moment().endOf('month')],
            'Último mes': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            alwaysShowCalendars : true,
            opens: 'left',
            autoApply: true,
        }, date_export);
    });
}

export function index_reload(){
    dt.ajax.reload();
}